<div class="modal fade" id="{{ modalId() }}" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable {{ size() }}">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">
          {{ modalTitle() }}
        </h1>
        <button type="button" class="btn-close" 
          data-bs-dismiss="modal" aria-label="Close"
          (click)="onCancel()">
        </button>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-12 mt-4 mb-3">
            <div class="invoice-value text-center">
              {{
              invoice?.amount > 0
              ? (invoice?.amount | customCurrency)
              : "R$ 0,00"
              }}
            </div>
          </div>
        </div>

        <div class="row payment-options-icons text-center p-1">
          <div class="col-6 d-grid p-0 cursor-pointer" (click)="openModal(PaymentType.CREDITO)">
            <i class="bi bi-credit-card m-1" style="color: green; font-size: 1.5rem;"></i>
            <span>Crédito</span>
          </div>
          
          <div class="col-6 d-grid justify-content-center p-0 cursor-pointer"
            (click)="openModal(PaymentType.PIX)">
            <mat-icon class="pix-mat-icon m-1" svgIcon="pix-green"></mat-icon>
            <span>PIX</span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="row">
          <div class="col-12 text-end">
            <b>Vencimento:</b>
            {{ invoice?.dueDate | date : "dd/MM/yyyy" : "+0000" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-payment-invoice-modal #paymentModal [modalId]="paymentModalId" 
  [paymentType]="paymentType" [reloadPage]="false"
  [paymentInvoiceModalData]="paymentInvoiceModalData"
  (confirmActionChange)="onModalConfirm($event)">
</app-payment-invoice-modal>